import React, {Component} from "react";
import styled from "styled-components";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import AppBar from "@material-ui/core/AppBar";
import CloseIcon from "@material-ui/icons/Close";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import {withStyles} from "@material-ui/core/styles";
import {
    ASK_FOR_QUOTE_LABEL,
    ELIGIBILITY_CUIVRE_TITLE,
    ELIGIBILITY_FIBRE_DEDIEE_TITLE,
    ELIGIBILITY_MOBILE_TITLE,
    ELIGIBILITY_MUTUALISEE_DEDIEE_TITLE,
    ERROR_TEXT_NETWORK,
    ERROR_TEXT_NO_RESULT,
    BUTTON_TEXT_COMMANDER,
    BUTTON_TEXT_DEVIS
} from "../../text.js";
import {
    getEligibilityForCuivreByTel,
    getEligibilityForMobileByPosition,
    getOffreCuivreByAddress,
    logEvent
} from "../../services/api.js";
import AskForNum from "./AskForNum/AskForNum";
import {Computer, Router, SignalCellular3Bar, SignalCellularAlt} from '@material-ui/icons';
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import classNames from 'classnames';
import {Divider} from "@material-ui/core";

const urlCommandeWeb = process.env.REACT_APP_COMMANDE_WEB_URL;
const urlCommandeWebMobile = urlCommandeWeb + "/mobile";
const urlCommandeWebV8 = urlCommandeWeb + "/v8/test?address=";

const GridListContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  @media only screen and (min-width: 1100px) {
    flex-wrap: nowrap;
  }
`;
const ListContainer = styled.div`
  display: flex;
  width: 100%;
  @media only screen and (min-width: 900px) {
    width: 48%;
    margin: 0.5em;
  }
  @media only screen and (min-width: 1100px) {
    width: 47%;
    margin: 0.5em;
  }
`;
const LoadingContainer = styled.div`
  justify-content: center;
  display: flex;
  width: 100%;
  align-self: center;
`;

const styles = theme => ({
    appBar: {
        position: "relative",

        backgroundImage: "url('/logo_celeste_blanc.png')",
        backgroundSize: '100px',
        backgroundRepeat: 'no-repeat',
        backgroundPositionY: '10px',
        backgroundPositionX: '10px',
        paddingLeft: '6.3em',
        [theme.breakpoints.down("420")]: {
            paddingLeft: '2.5em',
            backgroundImage: "url('/etoile1_blanc.png')",
            backgroundSize: '45px',
            backgroundRepeat: 'no-repeat',
            backgroundPositionY: '10px',
            backgroundPositionX: '5px',
        }
    },
    flex: {
        flex: 1,
        display: "flex"
    },

    dialogContent: {
        backgroundColor: '#f6f6f6',
    },
    dialogContentSize: {
        padding: '0'
    },
    fontSize: {
        fontSize: '0.8em'
    },
    promo: {
        fontSize: '0.8em',
        color: '#016500'
    },
    iconPromo: {
        float: 'left',
        marginRight: '5px',
        paddingBottom: '15px',
    },
    dialogSize: {

        [theme.breakpoints.up("md")]: {
            height: "55vh",
            width: "98%",
            margin: "0 auto",
            top: "10vh",
            minWidth: "auto",
            minHeight: "600px"
        },
        [theme.breakpoints.up("lg")]: {
            width: "64vw",
            height: "54vh",
            minWidth: "1170px",
            minHeight: "600px"
        },
    },
    blocInfo: {
        backgroundColor: '#fff',
    },
    dialogCustom: {
        width: '50%',
        height: '90%',
        margin: '1em auto',
    },
    divider: {
        width: '50%',
        marginTop: '3em',
        marginLeft: 'auto',
        marginRight: 'auto',
        backgroundColor: 'grey'
    },
    listContent: {
        width: '100%',
        padding: '0'
    },
    detailsTech: {
        lineHeight: '0.8rem',
        padding: '0.1em',
        paddingLeft: '1.7em',
    },
    blockTech: {
        fontSize: '1em',
        height: '14.5em',


        [theme.breakpoints.up("958")]: {
            display: 'none',
        },
        [theme.breakpoints.up("1120")]: {
            position: 'absolute',
            bottom: '4em',
            display: 'block !important',
        },

    },
    blockButton: {
        fontSize: '1em',
        position: 'absolute',
        bottom: '0em',
        height: '2em',
        display: 'block !important',
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: '0.5em',
        textAlign: 'center',
    },
    technoTitre:
        {
            "& *": {
                color: "white",
                fontWeight: "bold"
            },
            backgroundColor: "gray",
            marginBottom: "0.5em",

            [theme.breakpoints.down("sm")]: {
                paddingBottom: "3px",
                paddingTop: "3px",
            }
        },
    titreIcone: {
        margin: '0'
    },
    titreIconeTech: {
        margin: '0',
        fontSize: '0.8em',
        color: "#156bb4"
    },
    titreTech: {
        fontSize: '0.8em',
        color: "#156bb4"
    },
    fibre_dediee: {
        backgroundColor: "#48639a",
    },
    fibre_mutualisee: {
        backgroundColor: "#70a181",
    },
    cuivre: {
        backgroundColor: "#d89c60",
    },
    mobile: {
        backgroundColor: "#cf9486",
    },
    resultat: {
        paddingTop: '0',
        paddingBottom: '0'
    }
});

class ErrorPasResultatClass extends Component {

    render() {

        return (
            <ListItem style={{
                paddingTop: "0",
                height: '2em'
            }}>
                <ListItemIcon>
                    <CloseIcon style={{
                        color: "#ff0000",
                        margin: '0'
                    }}
                    /></ListItemIcon>
                <ListSubheader disableSticky
                               className={this.props.classes.fontSize}>{ERROR_TEXT_NO_RESULT}</ListSubheader>
            </ListItem>
        );
    }
};

const ErrorPasResultat = withStyles(styles)(ErrorPasResultatClass);


class ResultAddress extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: false,
            isLoading: true,
            isTryNewNum: false,
            eligibilite: {
                cuivre: null,
                mobileFibre: null,
                fibreDediee: null,
                hertzien: null,
                fibreMutualise: null
            }
        };
    }

    componentWillReceiveProps(nextProps) {
        if (
            JSON.stringify(nextProps.value) !== JSON.stringify(this.props.value) &&
            nextProps.value
        ) {
            this.setState({
                error: false,
                isLoading: true,
                eligibilite: {cuivre: null, mobileFibre: null, detailsDediee: null}
            });
            getOffreCuivreByAddress(nextProps.value.rue, nextProps.value.insee).then(
                offreCuivreByAddress => {
                    if (!offreCuivreByAddress || !offreCuivreByAddress.data) {
                        this.setState({
                            isLoading: false,
                            error: true
                        });
                        return;
                    }
                    getEligibilityForMobileByPosition(nextProps.value.position).then(
                        eligibilityForMobile => {
                            if (!eligibilityForMobile || !eligibilityForMobile.data) {
                                this.setState({
                                    isLoading: false,
                                    error: true
                                });
                                return;
                            }
                            this.setState({
                                isLoading: false,
                                error: false,
                                useNumero: !!offreCuivreByAddress.data.useNumero,
                                eligibilite: {
                                    cuivre: offreCuivreByAddress.data.offres,
                                    mobile: eligibilityForMobile.data.mobile,
                                    fibreDediee: eligibilityForMobile.data.fibre.find(
                                        fibre => fibre.type === "dediee"
                                    ),
                                    hertzien: eligibilityForMobile.data.hertzien,
                                    detailsDediee: eligibilityForMobile.data.details_fibre_dediee,
                                    fibreMutualise: eligibilityForMobile.data.fibre.find(
                                        fibre => fibre.type === "mutualisee"
                                    )
                                }
                            });
                        }
                    );
                }
            );
        }
    }

    handleOk = () => {
        this.props.onClose();
    };

    handleContactForm = () => {

        logEvent({type: "demandeDeDevis"});

        this.props.openContactForm();
    };

    searchForNum = num => {
        this.setState({
            isTryNewNum: true
        });
        getEligibilityForCuivreByTel(num).then(eligibilityForCuivre => {
            if (!eligibilityForCuivre || !eligibilityForCuivre.data) {
                this.setState({isTryNewNum: false});
                return;
            }

            this.setState({
                useNumero: true,
                isTryNewNum: false,
                eligibilite: {
                    ...this.state.eligibilite,
                    cuivre: eligibilityForCuivre.data
                }
            });
        });
    };

    render() {
        const {isLoading, error} = this.state;
        const {value, classes, ...other} = this.props;
        const globalCuivre =
            this.state.eligibilite.cuivre && this.state.eligibilite.cuivre.length > 0
                ? this.state.eligibilite.cuivre.reduce((l, e) => {
                    return e.nbPairesDisponibles > l.nbPairesDisponibles ? e : l;
                })
                : null;

        return (
            <Dialog
                className={classNames(classes.dialogContent, classes.dialogSize)}
                classes={{paper: classes.dialogContent}}
                fullScreen
                disableBackdropClick
                disableEscapeKeyDown
                {...other}
            >
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <Typography variant="h6" color="inherit" className={classes.flex}>
                            {value && `Résultats pour ${value.rue}, ${value.codePostal} ${value.ville}`}
                        </Typography>
                        <IconButton color="inherit" onClick={this.handleOk}>
                            <CloseIcon/>
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent className={classNames(classes.dialogContent, classes.flex, classes.dialogContentSize)}>
                    {isLoading || error ? (
                        isLoading ? (
                            <LoadingContainer>
                                <CircularProgress/>
                            </LoadingContainer>
                        ) : (
                            <div>{ERROR_TEXT_NETWORK}</div>
                        )
                    ) : (
                        <GridListContainer>
                            <ListContainer className={classes.blocInfo}>
                                <List className={classes.listContent}>
                                    <ListItem className={classNames(classes.technoTitre, classes.fibre_dediee)}>
                                        <ListItemIcon className={classes.titreIcone}><Computer/> </ListItemIcon>
                                        <ListSubheader disableSticky className={classes.fontSize}>
                                            {ELIGIBILITY_FIBRE_DEDIEE_TITLE}
                                        </ListSubheader>
                                    </ListItem>
                                    {(!this.state.eligibilite.fibreDediee ||
                                        this.state.eligibilite.fibreDediee.length === 0) && (
                                        <ErrorPasResultat/>
                                    )}

                                    {this.state.eligibilite.fibreDediee && (
                                        <ListItem key={this.state.eligibilite.fibreDediee.label}
                                                  className={classes.resultat}>
                                            <ListItemText>
                                               <Typography color={"primary"} className={classes.fontSize}>
                                                   {this.state.eligibilite.fibreDediee.label}
                                           </Typography>
                                            
                                            </ListItemText>

                                        </ListItem>
                                    )}

                                    {this.state.eligibilite.detailsDediee && (
                                        <List className={classes.blockTech}>
                                            <ListItem>
                                                <ListItemIcon
                                                    className={classes.titreIconeTech}><SignalCellular3Bar/>
                                                </ListItemIcon>
                                                <ListSubheader disableSticky className={classes.titreTech}>
                                                    Détails techniques</ListSubheader>
                                            </ListItem>
                                            <ListItem className={classes.detailsTech}>
                                                <ListItemText>
                                                    <Typography color={"primary"} className={classes.fontSize}>
                                                        Débits garantis et symétriques jusqu'à 10 Gbit/s
                                                    </Typography>
                                                    <Typography color={"primary"} className={classes.fontSize}>
                                                        Garantie de Temps de Rétablissement de 4h
                                                    </Typography>
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem className={classes.detailsTech}>
                                                <ListItemText>
                                                    {true && (
                                                        <Typography color={"primary"} className={classes.fontSize}>
                                                            {this.state.eligibilite.detailsDediee.nb_reseaux} réseaux
                                                            présents</Typography>
                                                    )}
                                                    {this.state.eligibilite.detailsDediee.nb_reseaux === 1 && (
                                                        <Typography color={"primary"} className={classes.fontSize}>
                                                            {this.state.eligibilite.detailsDediee.nb_reseaux} réseau
                                                            présent
                                                        </Typography>
                                                    )}
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem className={classes.detailsTech}>
                                                <ListItemText>
                                                    {this.state.eligibilite.detailsDediee.ouvert === 1 && (
                                                        <Typography color={"primary"} className={classes.fontSize}>
                                                            Présence du réseau CELESTE : oui
                                                        </Typography>
                                                    )}
                                                    {this.state.eligibilite.detailsDediee.ouvert === 2 && (
                                                        <Typography color={"primary"} className={classes.fontSize}>
                                                            Présence du réseau CELESTE :
                                                            prévu {this.state.eligibilite.detailsDediee.dateOuverture}
                                                        </Typography>
                                                    )}
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem className={classes.detailsTech}>
                                                <ListItemText>
                                                    <Typography color={"primary"} className={classes.fontSize}>
                                                        Offre de double parcours optique
                                                        : {this.state.eligibilite.detailsDediee.double_parcours ? 'oui' : 'non'}
                                                    </Typography>
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem className={classes.detailsTech}>
                                                <ListItemText>
                                                    <Typography color={"primary"} className={classes.fontSize}>
                                                        {this.state.eligibilite.detailsDediee.double_parcours ? 'Lien de backup possible' : ''}
                                                    </Typography>
                                                </ListItemText>
                                            </ListItem>
                                        </List>
                                        )}
                                    {this.state.eligibilite.fibreDediee && value && (
                                        <List className={classes.blockButton}>
                                            <a href={urlCommandeWebV8 + value.rue + ' ' + value.codePostal + ' ' + value.ville + '&linkType=Fibre dédiée'} target="_blank" rel="noopener noreferrer"><Button variant="contained" color="primary">{BUTTON_TEXT_DEVIS}</Button></a>
                                        </List>
                                    )}
                                </List>
                            </ListContainer>

                            <ListContainer className={classes.blocInfo}>
                                <List className={classes.listContent}>
                                    <ListItem className={classNames(classes.technoTitre, classes.fibre_mutualisee)}>
                                        <ListItemIcon className={classes.titreIcone}><Computer/></ListItemIcon>
                                        <ListSubheader disableSticky className={classes.fontSize}>
                                            {ELIGIBILITY_MUTUALISEE_DEDIEE_TITLE}
                                        </ListSubheader>
                                    </ListItem>
                                    {(!this.state.eligibilite.fibreMutualise ||
                                        this.state.eligibilite.fibreMutualise.length === 0) && (
                                        <ErrorPasResultat/>
                                    )}

                                    {this.state.eligibilite.fibreMutualise && (
                                        <ListItem key={this.state.eligibilite.fibreMutualise.label}
                                                  className={classes.resultat}>

                                            <ListItemText>
                                                <Typography color={"primary"} className={classes.fontSize}>
                                                    {this.state.eligibilite.fibreMutualise.label}
                                                </Typography>
                                            </ListItemText>
                                        </ListItem>
                                    )}

                                    {
                                        this.state.eligibilite.fibreMutualise &&
                                        (
                                          typeof this.state.eligibilite.fibreMutualise.tauxCouverture && (
                                          this.state.eligibilite.fibreMutualise.tauxCouverture !== 0 ||
                                          this.state.eligibilite.fibreMutualise.logementsDesservis ||
                                          this.state.eligibilite.fibreMutualise.operateurImmeuble)
                                        ) && (
                                        <List className={classes.blockTech}>
                                            <ListItem>
                                                <ListItemIcon
                                                    className={classes.titreIconeTech}><SignalCellular3Bar/>
                                                </ListItemIcon>
                                                <ListSubheader disableSticky className={classes.titreTech}>
                                                    Détails techniques</ListSubheader>
                                            </ListItem>

                                            <ListItem className={classes.detailsTech}>
                                                <ListItemText>
                                                    {
                                                        typeof this.state.eligibilite.fibreMutualise.tauxCouverture &&
                                                        this.state.eligibilite.fibreMutualise.tauxCouverture !== 0 && (
                                                        <Typography color={"primary"} className={classes.fontSize}>
                                                            Taux de
                                                            couverture: {this.state.eligibilite.fibreMutualise.tauxCouverture}%
                                                        </Typography>
                                                    )}
                                                </ListItemText>
                                            </ListItem>

                                            <ListItem className={classes.detailsTech}>
                                                <ListItemText>
                                                    {this.state.eligibilite.fibreMutualise.logementsDesservis && (
                                                        <Typography color={"primary"} className={classes.fontSize}>
                                                            Nombre de logements desservis par le point de mutualisation
                                                            : {this.state.eligibilite.fibreMutualise.logementsDesservis}
                                                        </Typography>
                                                    )}
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem className={classes.detailsTech}>
                                                <ListItemText>
                                                    {this.state.eligibilite.fibreMutualise.operateurImmeuble && (
                                                        <Typography color={"primary"} className={classes.fontSize}>
                                                            Opérateur d'immeuble
                                                            : {this.state.eligibilite.fibreMutualise.operateurImmeuble}
                                                        </Typography>
                                                    )}
                                                </ListItemText>
                                            </ListItem>
                                        </List>
                                    )}
                                    {this.state.eligibilite.fibreMutualise && value && (
                                        <List className={classes.blockButton}>
                                            <a href={urlCommandeWebV8 + value.rue + ' ' + value.codePostal + ' ' + value.ville + '&linkType=FTTH'} target="_blank" rel="noopener noreferrer"><Button variant="contained" color="primary">{BUTTON_TEXT_COMMANDER}</Button></a>
                                        </List>
                                    )}
                                </List>
                            </ListContainer>
                            <ListContainer className={classes.blocInfo}>
                                <List className={classes.listContent}>
                                    <ListItem className={classNames(classes.technoTitre, classes.cuivre)}>
                                        <ListItemIcon className={classes.titreIcone}><Router/> </ListItemIcon>
                                        <ListSubheader disableSticky className={classes.fontSize}>
                                            {ELIGIBILITY_CUIVRE_TITLE}
                                        </ListSubheader>
                                    </ListItem>
                                    {!this.state.useNumero ? (
                                        this.state.isTryNewNum ? (
                                            <LoadingContainer> <CircularProgress/> </LoadingContainer>
                                        ) : (
                                            <AskForNum searchForNum={this.searchForNum}/>
                                        )
                                    ) : (
                                        <div>
                                            {(!this.state.eligibilite.cuivre ||
                                                this.state.eligibilite.cuivre.length === 0) && (
                                                <ErrorPasResultat/>
                                            )}
                                            {this.state.eligibilite.cuivre &&
                                            this.state.eligibilite.cuivre.map(
                                                cuivre => (
                                                    <ListItem key={cuivre.label}
                                                              className={classes.resultat}>
                                                        <ListItemText>
                                                            <Typography color={"primary"}
                                                                        className={classes.fontSize}>
                                                                {cuivre.label}
                                                            </Typography>
                                                        </ListItemText>
                                                    </ListItem>
                                                )
                                            )}
                                            {this.state.eligibilite.cuivre &&
                                            this.state.eligibilite.cuivre.length > 0 && (
                                                <List className={classes.blockTech}>
                                                    <ListItem>
                                                        <ListItemIcon
                                                            className={classes.titreIconeTech}><SignalCellular3Bar/>
                                                        </ListItemIcon>
                                                        <ListSubheader disableSticky className={classes.titreTech}>
                                                            Détails techniques</ListSubheader>
                                                    </ListItem>
                                                    <ListItem className={classes.detailsTech}>
                                                        <ListItemText>
                                                            <Typography color={"primary"} className={classes.fontSize}>
                                                                {`Longueur : ${globalCuivre.distanceMetres} Mètres`}
                                                            </Typography>
                                                        </ListItemText>
                                                    </ListItem>

                                                    <ListItem className={classes.detailsTech}>
                                                        <ListItemText>
                                                            <Typography color={"primary"} className={classes.fontSize}>
                                                                {`Atténuation : ${parseFloat(globalCuivre.attenuationDb).toFixed(2)} dB`}
                                                            </Typography>
                                                        </ListItemText>
                                                    </ListItem>
                                                </List>
                                            )}
                                        </div>
                                    )}
                                    {this.state.eligibilite.cuivre && globalCuivre != null && value && (
                                        <List className={classes.blockButton}>
                                            <a href={urlCommandeWebV8 + value.rue + ' ' + value.codePostal + ' ' + value.ville + '&linkType=' + (globalCuivre.technologie === 'EFM' ? 'SDSL' : 'ADSL/VDSL')} target="_blank" rel="noopener noreferrer"><Button variant="contained" color="primary">{BUTTON_TEXT_COMMANDER}</Button></a>
                                        </List>
                                    )}
                                </List>
                            </ListContainer>

                            <ListContainer className={classes.blocInfo}>
                                <List className={classes.listContent}>
                                    <ListItem className={classNames(classes.technoTitre, classes.mobile)}>
                                        <ListItemIcon className={classes.titreIcone}><SignalCellularAlt/>
                                        </ListItemIcon>
                                        <ListSubheader disableSticky className={classes.fontSize}>
                                            {ELIGIBILITY_MOBILE_TITLE}
                                        </ListSubheader>
                                    </ListItem>

                                    {(!this.state.eligibilite.mobile ||
                                        this.state.eligibilite.mobile.length === 0) && (
                                        <ErrorPasResultat/>
                                    )}

                                    {this.state.eligibilite.mobile &&
                                    this.state.eligibilite.mobile.map(mobile => (
                                        <ListItem key={mobile.label} className={classes.resultat}>
                                            <ListItemText>
                                                <Typography color={"primary"} className={classes.fontSize}>
                                                    {mobile.label}
                                                </Typography>
                                            </ListItemText>
                                        </ListItem>
                                    ))}
                                    <List className={classes.blockButton}>
                                        <a href={urlCommandeWebMobile} target="_blank" rel="noopener noreferrer"><Button variant="contained" color="primary">{BUTTON_TEXT_COMMANDER}</Button></a>
                                    </List>
                                    {this.state.eligibilite.hertzien && (
                                        <Divider className={classes.divider} variant={"middle"}/>
                                    )}
                                </List>
                                <List className={classes.blockTech}>

                                    {this.state.eligibilite.hertzien && (
                                        <>

                                            <ListItem key={this.state.eligibilite.hertzien.label}
                                                      className={classes.resultat}>
                                                <ListItemText>
                                                    <Typography color={"primary"} className={classes.fontSize}>
                                                        {this.state.eligibilite.hertzien.label}
                                                    </Typography>
                                                </ListItemText>
                                            </ListItem>
                                        </>
                                    )}
                                </List>
                            </ListContainer>
                        </GridListContainer>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={this.handleContactForm}
                        color="primary"
                    >
                        {ASK_FOR_QUOTE_LABEL}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles(styles)(ResultAddress);
